import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ValidationTopErrorMessage from '../portal/controls/validationTopErrorMessage';
import { Button, Toggle, ButtonType } from '@checkmarx/cx-ui';
import TextfieldFloatingText from '../portal/textfieldFloatingText';
import PortalTextBox from '../portal/portalTextBox';
import ToastrService from '../../services/ui/toastrService';
import ToastrLevelsEnum from '../../services/enums/toastrLevelsEnum';
import ScreenLoaderContainer from '../portal/controls/screenLoaderContainer';


@inject('translationsStore', 'masterAccessControlStore')
@observer
export default class RightMasterACPanel extends Component {
    state = {
        isFetching : false
    }

    t = this.props.translationsStore.translate;

    async componentDidMount () {
        this.setState({isFetching: true});
        await this.props.masterAccessControlStore.getMasterAccessControl();
        this.setState({isFetching: false});
    }

    componentWillUnmount() {
        this.props.masterAccessControlStore.reset();
    }

    handleLocalURLChange = e => this.props.masterAccessControlStore.setLocalURL(e.target.value);
    handleLocalURLOnBlur = e => this.props.masterAccessControlStore.validateLocalURL();

    handleNameChange = e => this.props.masterAccessControlStore.setName(e.target.value);
    handleNameOnBlur = e => this.props.masterAccessControlStore.validateName();
    
    handleActiveChange = e => this.props.masterAccessControlStore.setActive(e.target.checked);

    handleSubmitForm = async (e) => {

        e.preventDefault();

        this.props.masterAccessControlStore.setSaveMasterACErrorMessage('');

        const isValid = this.props.masterAccessControlStore.validateMasterACForm();

        if (isValid === false) {

            const validationErrorMessage = this.t('FORM_IS_NOT_COMPLETE_FILL_REQUIRED_FIELDS');
            this.props.masterAccessControlStore.setSaveMasterACErrorMessage(validationErrorMessage);
            return;
        }

        await this.props.masterAccessControlStore.SaveMasterAC();
    
        if(!this.props.masterAccessControlStore.isExistSaveErrorMessage()){
            var level = ToastrLevelsEnum.SUCCESS;
            var message = 'Primary Access Control settings have been updated successfully';
            ToastrService.triggerToastr({ level, message });
        }
    };


    render() {

        const {saveMasterACErrorMessage, localURLValidationMessage, 
            savingMasterAC, values, nameValidationMessage } = this.props.masterAccessControlStore;

        return this.state.isFetching ?
                    <ScreenLoaderContainer /> :
                    <div>
                        <div className='master-ac-right-title'>
                            {this.t('MASTER_ACCESS_CONTROL')}
                        </div>
                        <div className='master-ac-right-sub-title'>
                            {this.t('MASTER_ACCESS_CONTROL_SUB_TITLE')}
                        </div>
                        <form onSubmit={this.handleSubmitForm}>
                            <div style={{paddingRight: '32px', minHeight: '405px'}}>
                                <ValidationTopErrorMessage errorMessage={saveMasterACErrorMessage} />
                                <Toggle
                                    icons={false}
                                    onChange={this.handleActiveChange}
                                    disabled={savingMasterAC}
                                    checked={values.active}
                                    text={this.t('ENABLE_MASTER_ACCESS_CONTROL')}
                                    dataCy='is-active-toggle-button'
                                />
                                <PortalTextBox
                                    hintText={this.t('LOCAL_BASE_URL')}
                                    floatingLabelText={<TextfieldFloatingText title={this.t('LOCAL_BASE_URL')} required={true} />}
                                    onChange={this.handleLocalURLChange}
                                    onBlur={this.handleLocalURLOnBlur}
                                    width='33%'
                                    errorText={localURLValidationMessage}
                                    disabled={savingMasterAC}
                                    value={values.localURL}
                                    dataCy='local-base-url'
                                />
                                <PortalTextBox
                                    hintText={this.t('NAME')}
                                    floatingLabelText={<TextfieldFloatingText title={this.t('NAME')} required={true} />}
                                    onChange={this.handleNameChange}
                                    onBlur={this.handleNameOnBlur}
                                    width='33%'
                                    errorText={nameValidationMessage}
                                    disabled={savingMasterAC}
                                    value={values.name}
                                    dataCy='name-input'
                                />
                                <div style={{paddingTop: '25px'}}>                    
                                    <Button
                                        dataCy='master-ac-save'
                                        type='submit'
                                        style={{float: 'right'}}
                                        inProgress={savingMasterAC}
                                        text={this.t('SAVE')} >
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>;
    }
}